<template>
  <ShareNetwork
    :network="network"
    :url="url"
    :title="title"
    :description="description"
    :quote="quote"
    :twitter-user="twitterUser"
    ><slot
  /></ShareNetwork>
</template>

<script setup>
const props = defineProps({
  network: {
    type: String,
    required: true,
  },
  url: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  quote: {
    type: String,
    required: true,
  },
  twitterUser: {
    type: String,
    required: true,
  },
});
</script>
